/**
 * Drafted placements that have not been allocated yet, kept where anything
 * that can take the user away from the roster can see them: the browser
 * (refresh / close), the scheduler's tabs, the week stepper. The board sets
 * the count; the others ask before leaving.
 */

let pending = 0;
const listeners = new Set<(count: number) => void>();

export const LEAVE_MESSAGE = (count: number): string =>
	`${count} drafted ${count === 1 ? "placement has" : "placements have"} not been allocated yet. Leave anyway and drop ${count === 1 ? "it" : "them"}?`;

const onBeforeUnload = (event: BeforeUnloadEvent): void => {
	if (pending > 0) {
		event.preventDefault();
		// Older browsers read the return value; modern ones show their own text.
		event.returnValue = "";
	}
};

export function setPendingDraftCount(count: number): void {
	const was = pending;
	pending = count;
	if (typeof window !== "undefined") {
		if (was === 0 && count > 0) window.addEventListener("beforeunload", onBeforeUnload);
		if (was > 0 && count === 0) window.removeEventListener("beforeunload", onBeforeUnload);
	}
	listeners.forEach((listener) => listener(count));
}

export const getPendingDraftCount = (): number => pending;

export function subscribePendingDrafts(listener: (count: number) => void): () => void {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
}

/**
 * True when it is fine to leave: nothing drafted, or the user chose to drop
 * the drafts. The caller then clears them (or they die with the board).
 */
export function confirmLeaveWithDrafts(): boolean {
	if (pending === 0) return true;
	return window.confirm(LEAVE_MESSAGE(pending));
}
